import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Redirect, useHistory, withRouter } from "react-router-dom";

import { useSignoutMutation } from "../../store/api/authApi";
import { SigninResponse } from "../../interfaces";
import { useSession } from "../../components/Hooks/UserHooks";
import { logout } from "../../store/slices/authSlice";

const LogoutPageComponent = (props: any) => {
  const dispatch = useDispatch();
  const { session } = useSession();
  const history = useHistory();
  const [signout, { isSuccess }] = useSignoutMutation();

  useEffect(() => {
    const doSignout = async () => {
      if (session && session.refreshToken) {
        try {
          await signout({
            refreshToken: (session as SigninResponse)?.refreshToken,
          }).unwrap();
        } catch (err) {
        } finally {
          dispatch(logout());
          localStorage.removeItem("session");
          history.replace("/login");
        }
      }
    };
    doSignout();
  }, []);

  if (isSuccess) {
    return <Redirect to="/login" />;
  }

  return <></>;
};

export const LogoutPage = withRouter(LogoutPageComponent);
